import { roundSizeChoices as roundChoices } from '@/services/product-rounds'
import { revenueChoices } from '@/services/revenue'
import { monthlyRecurringRevenueChoices } from '@/services/monthly-recurring-revenue'

export function getCorespondingDataArray(key) {
  switch (key) {
    case 'previous_rounds_size':
      return roundChoices
    case 'round_size':
      return roundChoices
    case 'annual_revenue':
      return revenueChoices
    case 'monthly_recurring_revenue':
      return monthlyRecurringRevenueChoices
  }
}
